import React from 'react'
import { Row, Col, Table } from 'reactstrap';
import { Link } from 'react-router'

import { renderIconSpecialties } from '../../provider/utils'
import { capitalizeFirstLetter } from '../../utils/parse'

import Loader from '../../core/components/Loader'
import DashboardDatas from './DashboardDatas'
import MapRegion from './MapRegion'

import '../styles/dashboard.css'



class Dashboard extends React.Component {

	constructor(props) { 
        super(props);
        this.state={
        };
        this.reloadComponent = this.reloadComponent.bind(this)
    }

    componentDidMount() {
        this.props.listLastLead(this.props.params.regionParam);
        this.props.listTask(this.props.params.regionParam);
        this.props.listAllDepartments()
    }

    reloadComponent(region){
        this.props.dataNewLead(30, region);
        this.props.dataNewProvider(30, region);
        this.props.dataNewTask(30, region);
        this.props.listLastLead(region);
        this.props.listTask(region)
    }

    renderLastLead(){
        const{ lead } = this.props;
        console.log('lead',lead.leads);
        const tr = lead.leads.list.map((lead) => {
            console.log('lead',lead);
            return (
                 <tr key={lead.id}>
                    <td>
                        <Link to={"/manager/prestataire/"+lead.id}><div className="company">{capitalizeFirstLetter(lead.company)}</div></Link>
                        <div className="name">{capitalizeFirstLetter(lead.first_name)} {capitalizeFirstLetter(lead.last_name)}</div>
                    </td>
                    <td>
                        <div className="region">{lead.region_name}</div>
                        <div className="departments">{lead.list_departments.join('-')}</div>
                    </td>
                    <td className="specialties"> {renderIconSpecialties(lead.specialties)}</td>
                    <td className="date">{lead.created_at}</td>
                </tr>
            )
        });
        return(
             <Table>
                <thead>
                  <tr>
                    <th>Dernières candidatures</th>
                    <th>Région</th>
                    <th>Compétences</th>
                    <th>Candidature</th>
                  </tr>
                </thead>
                <tbody>
                  {tr}
                </tbody>
              </Table>
        )
    }

    renderLastTask(){

        const{ task } = this.props;

        const tr = task.list.slice(0, 4).map((task) => {
            console.log('task',task);
            return (
                 <tr key={task.id}>
                    <td>
                         <Link to={"/manager/prestataire/"+task.id}><div className="company">{task.task}</div></Link>
                        <div className="name">{task.company}</div>
                    </td>
                    <td className="date">{task.updated_at}</td>
                </tr>
            )
        });

        return(
             <Table>
                <thead>
                  <tr>
                    <th>Prochaines tâches</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                    {tr}
                </tbody>
              </Table>
        )
    }

    render() {
    	
        const{ lead, datas, task, departments, user } = this.props;

    	return (
            <div className="page-manager page-dashboard">
                <div className="bloc-datas">
                    <Row>

                        <DashboardDatas newData={this.props.dataNewLead} datas={datas.lead} type="lead" params={this.props.params} />

                        <DashboardDatas newData={this.props.dataNewProvider} datas={datas.provider} type="provider" params={this.props.params} />

                        <DashboardDatas newData={this.props.dataNewTask} datas={datas.task} type="task" params={this.props.params} />

                        <Col xs="12" sm="3" className="map-responsive">
                            { departments.fulfilled &&
                                <MapRegion reloadComponent={this.reloadComponent} departments={departments} user={user} params={this.props.params} />
                            }
                        </Col>

                    </Row>
                </div>

                <div>
                    <Row>

                        <Col sm="8" className="lead-responsive">
                            <div className="bloc-list">
                            {lead.leads.fulfilled &&
                                this.renderLastLead()
                            }
                            {lead.leads.pending &&
                                <Loader />
                            }
                            </div>
                        </Col>

                        <Col sm="4">
                            <div className="bloc-list dashboard-table-task">
                                {this.renderLastTask()}
                            </div>
                        </Col>

                    </Row>
                </div>

            </div>
        )
    }
}


export default Dashboard



// WEBPACK FOOTER //
// ./src/btob/components/Dashboard.js